<template>
    <div class="apply_container" :style="{backgroundImage: `url(${bg2Icon})`}">
        <div class="apply_inner">
            <img class="apply_titImg" :src="applyIcon"/>
            <form style="font-size: 18px;margin-top: 76px">
                <div>
                    <label>
                        <i class="formStar">*</i>
                        <span class="formTitle">公司名称</span>
                        <input class="formInput" v-model="form.company" @blur="inputBlur('公司名称', 'company')" placeholder="以营业执照为准"/>
                        <p ref="formTip_公司名称" class="formTip">请输入公司名称</p>
                    </label>
                    <label style="margin-left: 169px">
                        <i class="formStar">*</i>
                        <span class="formTitle">所在地区</span>
                        <input class="formInput" v-model="form.region" @blur="inputBlur('所在地区', 'region')" placeholder="例: 北京市朝阳区"/>
                        <p ref="formTip_所在地区" class="formTip">请输入所在地区</p>
                    </label>
                </div>
                <div style="margin-top: 79px">
                    <label>
                        <i class="formStar">*</i>
                        <span class="formTitle">联系人</span>
                        <input class="formInput" v-model="form.contact" @blur="inputBlur('联系人', 'contact')" placeholder="请输入姓名"/>
                        <p ref="formTip_联系人" class="formTip">请输入联系人</p>
                    </label>
                    <label style="margin-left: 169px">
                        <i class="formStar">*</i>
                        <span class="formTitle">联系电话</span>
                        <input class="formInput" v-model="form.tel" @blur="inputBlur('联系电话', 'tel')" placeholder="请输入手机号"/>
                        <p ref="formTip_联系电话" class="formTip">请输入正确的手机号</p>
                    </label>
                </div>
                <div style="margin-top: 79px">
                    <label>
                        <i class="formStar" style="opacity: 0">*</i>
                        <span class="formTitle">邮箱</span>
                        <input class="formInput" v-model="form.email" @blur="inputBlur('邮箱', 'email')" placeholder="例：anyudevelop@163.com"/>
                        <p ref="formTip_邮箱" class="formTip">邮箱格式错误</p>
                    </label>
                    <label style="margin-left: 169px">
                        <i class="formStar">*</i>
                        <span class="formTitle">经营范围</span>
                        <input class="formInput" v-model="form.scope" @blur="inputBlur('经营范围', 'scope')" placeholder="请简略概括经营范围及使用用途"/>
                        <p ref="formTip_经营范围" class="formTip">请输入经营范围</p>
                    </label>
                </div>
            </form>
            <div class="apply_actionArea">
                <button class="apply_actionArea_btn" @click="submit">{{isLoading ? "正在提交申请..." : tipText}}</button>
            </div>
        </div>

    </div>
</template>
<script>
import ApplyIcon from "@/assets/apply.png"
import Bg2Icon from "@/assets/bg2.png"
import axios from "axios"
import qs from "qs"
export default {
    data () {
        return {
            applyIcon: ApplyIcon,
            bg2Icon: Bg2Icon,

            isLoading: false,
            tipText: '提交申请',
            
            form: {
                company: '',
                region: '',
                contact: '',
                tel: '',
                email: '',
                scope: '',
            },

            // 表单中字段验证状态 true:通过
            formV: {
                tel: true,
                email: true,
            }
        }
    },
    methods: {
        inputBlur (type, field) {
            if (String(this.form[field]) == '') {
                if (type != '邮箱') {
                    this.$refs['formTip_' + type].style.display = 'inline'
                }
            } else {
                this.$refs['formTip_' + type].style.display = 'none'
                // 表单验证
                switch (type) {
                    case '联系电话':
                        if (!/^1[123456789]\d{9}$/.test(this.form[field])) {
                            this.$refs['formTip_' + type].style.display = 'inline'
                            this.formV.email = false
                        } else {
                            this.formV.email = true
                        }
                    break
                    case '邮箱':
                        if (!/^[a-zA-Z0-9_]+@[a-zA-Z0-9_\.]+$/.test(this.form[field])) {
                            this.$refs['formTip_' + type].style.display = 'inline'
                            this.formV.tel = false
                        } else {
                            this.formV.tel = true
                        }
                    break
                    default: break
                }

            }
        },
        submit () {
            if (this.isLoading) {
                return false
            }
            let form = this.form
            if ( !form.company || !form.region || !form.contact || !form.tel || !form.scope ) {
                this.inputBlur('公司名称', 'company')
                this.inputBlur('所在地区', 'region')
                this.inputBlur('联系人', 'contact')
                this.inputBlur('联系电话', 'tel')
                this.inputBlur('经营范围', 'scope')
                return false
            }
            // 判断是否已验证通过
            for (let ite in this.formV) {
                if (this.formV[ite] == false) { return false }
            }

            this.isLoading = true

            // 转换邮箱格式
            let transEmail = form.email.replace("@", "(AT)").replace(".", "(DOT)").replace("com", "c0m")

            axios.get("https://test-0gpcz0gpd12dd1e0-1301487764.ap-shanghai.app.tcloudbase.com/cooperApply", {
                "params": {
                    company:    form.company,
                    contact:    form.contact,
                    email:      form.email,
                    region:     form.region,
                    scope:      form.scope,
                    tel:        form.tel
                }
            }).then((res) => {
                this.isLoading = false
                if (res.data.state == 1) {
                    axios.get("https://test-0gpcz0gpd12dd1e0-1301487764.ap-shanghai.app.tcloudbase.com/cooperSms", {
                        "params": {
                            company: form.company,
                            contact: form.contact,
                            email: transEmail,
                            region: form.region,
                            scope: form.scope,
                            tel: form.tel
                        }
                    }).then((res1) => {
                        if (res1.data.state == 1) {
                            this.tipText = "提交申请成功"
                            // 关闭当前
                            setTimeout(() => {
                                this.$emit("ret")
                                this.tipText = "提交申请"
                            }, 2000)
                        } else {
                            alert(res.data.msg)
                            this.tipText = "提交申请"
                        }
                    
                    }).catch((err1) => { 
                        this.tipText = "提交申请"
                     })
                } else {
                    alert(res.data.msg)
                    this.tipText = "提交申请"
                } 
            }).catch((err) => {
                this.isLoading = false
                this.tipText = "提交申请"
            })
            
        }
    },
    mounted () {
    }
}
</script>
<style scoped>
.apply_container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 809px;
    background-position: center;
    background-size: cover;
}
.apply_inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 1200px;
    background-color: #fff;
    border-radius: 8px;
    padding: 40px;
    padding-bottom: 0;
}
.apply_inner label {
    position: relative;
}
.apply_titImg {
    width: 447px;
    height: auto;
}
.apply_button {
    width: 198px;
    background: linear-gradient(90deg, #5F7EFF 0%, #4162FF 100%);
    box-shadow: 0px 1px 4px 0px rgba(66, 66, 66, 0.34);
    border-radius: 12px;
}
.formStar {
    color: #FF5959;
    font-size: 18px;
}
.formInput {
    width: 312px;
    height: 50px;
    border: 1px solid #D8D8D8;
    border-radius: 8px;
    font-size: 18px;
    padding-left: 16px;
    padding-right: 16px;
}
.formInput::-webkit-input-placeholder { /* WebKit browsers */
  color: #c1c1c1;
  font-size: 18px;
}
.formInput::-moz-placeholder { /* Mozilla Firefox 19+ */
  color: #c1c1c1;
  font-size: 18px;
}
.formTitle {
    display: inline-block;
    width: 80px;
    color: #515151;
}
.apply_actionArea_btn {
    background: linear-gradient(90deg, #5F7EFF 0%, #4162FF 100%);
    box-shadow: 0px 1px 4px 0px rgba(66, 66, 66, 0.34);
    border: 0;
    border-radius: 100px;
    color: #fff;
    font-size: 20px;
    padding: 15px 56px;
    margin-top: 73px;
    margin-bottom: 78px;
    letter-spacing: 4px;
    cursor: pointer;
    outline: none;
}
.formTip {
    position: absolute;
    left:115px;
    bottom:-35px;
    display: none;
    font-size:14px;
    color:#FF5959
}
</style>


// WEBPACK FOOTER //
// src/components/Main/apply.vue